import { ErrorAppointmentCode } from 'Pages/orders_design'

export const errorResponse = (value): boolean => {
	return (
		JSON.parse(value)?.error === ErrorAppointmentCode.e503 ||
		JSON.parse(value)?.error === ErrorAppointmentCode.e403
	)
}

export const formErrorResponse = (value): boolean => {
	return JSON.parse(value)?.businessErrorCode === ErrorAppointmentCode.e404
}
